import { User } from 'api/account/me/dtos';
import { RoleTypeEnum } from 'api/account/membership/dtos';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router-dom';
import routes from 'routes';
import { isDev } from 'utils';
import useAuth from './useAuth';

export const usePageTracking = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useTranslation();

  (window as any)['ga-disable-G-96GT5X232B'] = isDev();

  const sendPageViewEvent = (match: any) => {
    const route = match?.getAbsolute();
    const pageTitle = t(match?.title, { defaultValue: match?.title });

    if (!match?.title) return;

    // Only match pages with title
    gtag('event', 'page_view', {
      page_title: pageTitle,
      page_location: window.location.href,
      page_path: route,
      user_type: getUserType(user),
      custom_map: {
        user_type: getUserType(user),
      },
    });
  };

  useEffect(() => {
    if (isDev()) return;

    const matchedRoute = findRoute(routes, location.pathname);
    if (matchedRoute?.title) {
      document.title = t(matchedRoute.title, { defaultValue: matchedRoute.title });
    }

    sendPageViewEvent(matchedRoute);
    //eslint-disable-next-line
  }, [location.pathname]);
};

function findRoute(data: any, path: string) {
  for (const property in data) {
    if (property === 'route' || property === 'title') continue;
    const entry = data[property];

    let isMatch: any;
    let rootMatch: string | undefined;

    if ('getAbsolute' in entry && matchPath(entry.getAbsolute(), path)) {
      rootMatch = entry;
    }

    if (Object.keys(entry).length >= 2) {
      isMatch = findRoute(entry, path);
    }

    if (isMatch || rootMatch) return isMatch ?? entry;
  }
}

const getUserType = (user?: Partial<User>) => {
  let userType = 'unauthenticated';

  if (user?.role === RoleTypeEnum.OWNER) {
    userType = 'owner';
  } else if (user?.role === RoleTypeEnum.USER) {
    const matchedRoute = matchPath('b/:businessId/*', window.location.pathname);
    let isEmployee = false;

    if (matchedRoute?.params.businessId) {
      const currentMembership = user?.memberships?.find(
        (m) => m.businessId === Number(matchedRoute?.params.businessId),
      );

      isEmployee = Boolean(currentMembership?.employee?.id);
    }

    if (isEmployee) userType = 'employee';
    else userType = 'student';
  }

  return userType;
};
